"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DurableEntityBindingInfoReqFields {
    constructor(self, exists, batch) {
        this.self = self;
        this.exists = exists;
        this.batch = batch;
    }
}
exports.DurableEntityBindingInfoReqFields = DurableEntityBindingInfoReqFields;
class DurableEntityBindingInfo extends DurableEntityBindingInfoReqFields {
    constructor(self, exists, state, batch) {
        super(self, exists, batch);
        this.self = self;
        this.exists = exists;
        this.state = state;
        this.batch = batch;
    }
}
exports.DurableEntityBindingInfo = DurableEntityBindingInfo;
//# sourceMappingURL=durableentitybindinginfo.js.map